import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DidProvider, UpdateProviderRequest, DID } from 'voxloud-types/dist/models';
import { DidsService } from 'src/app/domains/dids/services';

@Component({
  selector: 'gdp-update-provider-popup',
  templateUrl: './update-provider-popup.component.html',
  styleUrls: ['./update-provider-popup.component.scss']
})
export class UpdateProviderPopupComponent implements OnInit {

  constructor(private fb: UntypedFormBuilder, private didsService: DidsService, private activeModal: NgbActiveModal,) { }
  public form: UntypedFormGroup;
  public did: DID;
  public availableProviders: Array<string>;
  public loading = {
    providers: false,
    submit: false
  };
  @Output() onUpdateProvider: EventEmitter<string> = new EventEmitter();
  @Output() onReplaceDid: EventEmitter<string> = new EventEmitter();

  ngOnInit(): void {
    this.form = this.fb.group({
      provider: [this.did.provider, [Validators.required]],
      providerReference: [null]
    });
    this.getProviders();
  }

  updateValue(provider: string) {
    this.form.get('provider').setValue(provider);
  }

  onSubmit() {
    if(this.form.valid) {
      const value = this.form.value;
      let payload: UpdateProviderRequest =  {
        provider: value.provider,
        reference_id: value.providerReference
      }
      this.loading.submit = true;
      this.didsService.updateDidProvider(payload, this.did.id).subscribe((res) => {
        this.onReplaceDid.emit(res);
        this.loading.submit = false;
        this.close();
      }, () => {
        this.loading.submit = false;
        this.close();
      })
    }
  }

  getProviders() {
    this.loading.providers = true;
    this.didsService.getProviders().subscribe((res: [DidProvider]) => {
      this.availableProviders = res.map(provider => provider.name);
      this.loading.providers = false;
    }, () => {
      this.loading.providers = false;
    });
  }

  close() {
    this.activeModal.close();
  }

  isFieldValid(name: string) {
    return (
      !this.form.get(name).valid && this.form.get(name).touched
    );
  }

}
